<template>
  <div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="亚洲" name="first"></el-tab-pane>
      <el-tab-pane label="欧洲" name="second"></el-tab-pane>
      <el-tab-pane label="非洲" name="third"></el-tab-pane>
      <el-tab-pane label="北美洲" name="fourth"></el-tab-pane>
      <el-tab-pane label="南美洲" name="five"></el-tab-pane>
      <el-tab-pane label="南极洲" name="six"></el-tab-pane>
      <el-tab-pane label="大洋洲" name="seven"></el-tab-pane>
    </el-tabs>
    <el-row class="container">
      <el-col :span="7">
        <el-card class="item">
          <div slot="header">
            <div>
              <el-button
                type="primary" @click="add(areaType.state.value)">添加国家</el-button>
            </div>
          </div>
          <div>

            <el-table
              ref="stateData"
              :maxHeight="tableHeight - 95 + 'px'"
              :data="stateData"
              highlight-current-row
              border
              :show-header = "false"
              @current-change="handleStateSelect"
              style="width: 100%">

              <el-table-column
                property="name"
                label="名称"
                width="120"
                align="center">
              </el-table-column>
              <el-table-column label="操作" show-overflow-tooltip align="center" >
                <template scope="scope" >
                  <div style="text-align: right;">
                    <el-button type="primary" size="small" @click="add(areaType.state.value,scope.row)">编辑</el-button>
                    <el-button type="danger" size="small" @click="delConfirm(areaType.state.value,scope.row)">删除</el-button>
                  </div>
                 </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>

      <el-col :span="7" style="margin-left: 10px;">
        <el-card class="item">
          <div slot="header">
            <div>
              <el-button
                type="primary" @click="add(areaType.province.value)">添加省市</el-button>
            </div>
          </div>
          <div>
            <div id="AAAAAA" :style="{height:tableHeight - 95 +'px'}">
            <el-table
              ref="provinceData"
              :maxHeight="tableHeight - 95 + 'px'"
              :data="provinceData"
              highlight-current-row
              border
              :show-header = "false"
              @current-change="handleProvinceSelect"
              style="width: 100%">

              <el-table-column
                property="name"
                label="名称"
                width="180"
                align="center">
              </el-table-column>
              <el-table-column label="操作" show-overflow-tooltip align="center">
                <template scope="scope">
                  <div style="text-align: right;">
                  <el-button type="primary" size="small" @click="add(areaType.province.value,scope.row)">编辑</el-button>
                  <el-button type="danger" size="small" @click="delConfirm(areaType.province.value,scope.row)">删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="8" style="margin-left: 10px;">
        <el-card class="item">
          <div slot="header">
            <el-button
              type="primary" @click="add(areaType.county.value)">添加区县</el-button>
            <span style="float:right;">
                    </span>
          </div>
          <div>
            <el-table
              ref="countyData"
              :maxHeight="tableHeight - 95 + 'px'"
              :data="countyData"
              highlight-current-row
              border
              :show-header = "false"
              style="width: 100%">

              <el-table-column
                property="name"
                label="名称"
                width="180"
                align="center">
              </el-table-column>
              <el-table-column label="操作" show-overflow-tooltip align="center">
                <template scope="scope">
                  <div style="text-align: right;">
                  <el-button type="primary" size="small" @click="add(areaType.county.value,scope.row)">编辑</el-button>
                  <el-button type="danger" size="small" @click="delConfirm(areaType.county.value,scope.row)">删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog
      title="添加|修改"
      :visible="statevisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="60%"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="名称" size="small" prop="name"><el-input v-model="form.name"></el-input></el-form-item>

        <el-form-item label="简称" size="small">
          <el-input v-model="form.region"></el-input>
        </el-form-item>

        <el-form-item label="纬度" size="small">
          <el-input v-model="form.lat"></el-input>
        </el-form-item>

        <el-form-item label="经度" size="small">
          <el-input v-model="form.lng"></el-input>
        </el-form-item>
        <el-form-item label="虚IP" size="small">
          <el-input v-model="form.virtual_ip"></el-input>
        </el-form-item>

        <el-form-item label="旗帜URL" size="small">
          <el-input v-model="form.national_flag"></el-input>
        </el-form-item>

        <el-form-item label="区域编码" size="small" prop="a_code">
          <el-input :disabled="this.form.id !=''" v-model="form.a_code"></el-input>
        </el-form-item>

        <el-form-item label="区域ID" size="small" prop="g_code">
          <el-input v-model.number="form.g_code"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="statevisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm()" size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import constants from '@/js/constants.js'
import { mapState } from 'vuex';
const areaType = constants.areaType;
const areaId =  constants.areaId;
    export default {
        name: "SysArea",
        data(){
          let checkGcode = (rule, value, callback) => {
            if (!value) {
              return callback(new Error('区域ID不能为空'));
            }
            if (!Number.isInteger(value)) {
              callback(new Error('请输入数字值'));
            } else {
              callback();
            }
          };
        return {
        activeName:'first',
        statevisible: false,
        stateData: [],
        provinceData: [],
        countyData: [],
        areaType,
        areaId,
        currentStateRow:null,
        currentProvinceRow:null,
        addType:1,
        pid:'',
        form:{
          id: '',
          name: '',
          parent_id: '',
          virtual_ip: '',
          lat: '',
          lng: '',
          region: '',
          national_flag: '',
          a_code: '',
          g_code: ''
        },
          rules: {
            name: [
              {required: true, message: '请输入名称', trigger: 'blur'},
            ],
            a_code: [
              {required: true, message: '请输入区域编码', trigger: 'blur'},
            ],
            g_code: [
              {required: true, validator: checkGcode, trigger: 'blur'},
            ],
          }
      }},
      computed: {
        ...mapState('main', ['tableHeight'])
      },
      created () {
          console.log(this.tableHeight)
        this.form.parent_id = this.areaId.AS.value;
        this.getArea(this.form.parent_id,this.areaType.state.value);
      },
      methods: {
        handleClick(tab, event){
          if(tab.name === "first"){
            this.form.parent_id = this.areaId.AS.value;
          }else if(tab.name === "second"){
            this.form.parent_id = this.areaId.EU.value;
          }else if(tab.name === "third"){
            this.form.parent_id = this.areaId.AF.value;
          }else if(tab.name === "fourth"){
            this.form.parent_id = this.areaId.NA.value;
          }else if(tab.name === "five"){
            this.form.parent_id = this.areaId.SA.value;
          }else if(tab.name === "six"){
            this.form.parent_id = this.areaId.AN.value;
          }else if(tab.name === "seven"){
            this.form.parent_id = this.areaId.OA.value;
          }
          this.getArea(this.form.parent_id,this.areaType.state.value);
        },
        handleStateSelect(val){
          this.provinceData = [];
          this.countyData = [];
          if(val){
            this.currentStateRow = val;
            this.getArea(this.currentStateRow.a_code,this.areaType.province.value);
          }

        },
        setStateCurrent(row) {
          this.$refs.stateData.setCurrentRow(row);
          this.getArea(this.currentStateRow.a_code,this.areaType.province.value);
        },
        handleProvinceSelect(val){
          this.countyData = [];
          if(val){
            this.currentProvinceRow = val;
            this.getArea(this.currentProvinceRow.a_code,this.areaType.county.value);
          }

        },
        setProvinceCurrent(row){
          this.$refs.provinceData.setCurrentRow(row);
          this.getArea(this.currentProvinceRow.a_code,this.areaType.county.value);
        },
        add(type,obj){
          this.addType = type;
          if(type == this.areaType.state.value){
            this.pid = this.form.parent_id;

          }else if(type == this.areaType.province.value){
            this.pid = this.currentStateRow.a_code;
          }else if(type == this.areaType.county.value){
            this.pid = this.currentProvinceRow.a_code;
          }
          if(obj){
            this.form.id = obj.id;
            this.form.name = obj.name;
            this.form.virtual_ip = obj.virtual_ip;
            this.form.lat = obj.lat;
            this.form.lng = obj.lng;
            this.form.region = obj.region;
            this.form.national_flag = obj.national_flag;
            this.form.a_code = obj.a_code;
            this.form.g_code = obj.g_code;
          }else{
            this.form.id = '';
            this.form.name = '';
            this.form.virtual_ip = '';
            this.form.lat = '';
            this.form.lng = '';
            this.form.region = '';
            this.form.national_flag = '';
            this.form.a_code = '';
            this.form.g_code = '';
          }
          this.statevisible = true;
        },
        delConfirm(type,row){
          this.$confirm('您确认要删除吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.del(type,row)
          }).catch(() => {

          });
        },
        del(type,obj){
          this.$axios.get(this.baseUrl3 + 'area/del/'+obj.id)
            .then(({ data: { msg, data, code } }) => {
              if (code == 20000) {
                if(type == this.areaType.state.value){
                  this.getArea(this.form.parent_id,this.areaType.state.value);
                }else if(type == this.areaType.province.value){
                  this.getArea(this.currentStateRow.a_code,this.areaType.province.value);
                }else if(type == this.areaType.county.value){
                  this.getArea(this.currentProvinceRow.a_code,this.areaType.county.value);
                }
                this.$message.success('操作成功')
              } else {
                this.$message({ showClose: true, message: msg, type: 'error' })
                console.log(msg)
              }
            })
            .catch(err => {
              console.log(err)
            })
        },
        getArea(pid,type){

          this.$axios.get(this.baseUrl3 + 'area/getAreasByParentId/'+pid)
            .then(({ data: { msg, data, code } }) => {
              if (code == 20000) {
                  if(type == this.areaType.state.value){
                    this.stateData = data;
                    //默认选择第一行
                    if(this.stateData.length>0){
                      this.setStateCurrent(this.stateData[0])
                    }

                  }else if(type == this.areaType.province.value){
                    this.provinceData = data;
                    //默认选择第一行

                    if(this.provinceData.length>0){
                      this.setProvinceCurrent(this.provinceData[0])
                    }
                  }else if(type == this.areaType.county.value){
                    this.countyData = data;
                  }
              } else {
                this.$message({ showClose: true, message: msg, type: 'error' })
                console.log(msg)
              }
            })
            .catch(err => {
              console.log(err)
            })
        },
        submitForm(){
          let _this = this
          this.$refs['form'].validate((valid) => {
            if (valid) {
              _this.saveState();
            } else {
              //this.$message({ showClose: true, message: '请正确填写信息', type: 'error' })
              return false;
            }
          });
        },
        saveState(){
          let model = {
            id: this.form.id,
            name: this.form.name,
            parent_a_code: this.pid,
            virtual_ip: this.form.virtual_ip,
            lat: this.form.lat,
            lng: this.form.lng,
            region: this.form.region,
            national_flag: this.form.national_flag,
            level: this.addType,
            a_code: this.form.a_code,
            g_code: this.form.g_code,
          }
          this.$axios.post(this.baseUrl3 + 'area/add', model)
            .then(({ data: { msg, data, code } }) => {
              if (code == 20000) {

                if(this.addType == this.areaType.state.value){
                  this.getArea(this.form.parent_id,this.areaType.state.value);
                }else if(this.addType == this.areaType.province.value){
                  this.getArea(this.currentStateRow.a_code,this.areaType.province.value);
                }else if(this.addType == this.areaType.county.value){
                  this.getArea(this.currentProvinceRow.a_code,this.areaType.county.value);
                }

                this.statevisible = false;
              } else {
                this.$message({ showClose: true, message: msg, type: 'error' })
                console.log(msg)
              }
            })
            .catch(err => {
              console.log(err)
            })
        }
      }
    }
</script>

<style scoped>
  .container{
    /*padding: 5px;*/
  }
  .container .item{
    height: 100%;
  }
  .container .item.icon{
    display: table-cell;
    vertical-align: middle;
    cursor: pointer;
  }
  .container >>> .el-card__body{
    padding: 0px;
  }
  .item_nav{
    display: block;
    cursor: pointer;
    padding: 0 8px;
  }
  .navItem{
    cursor: pointer;
  }

  .loadingIcon{
    width: 80px;
    height: 80px;
    animation: rotate 4s linear infinite;
  }

  @keyframes rotate{
    0%{
      transform: rotateZ(0deg);/*从0度开始*/
    }
    100%{
      transform: rotateZ(360deg);/*360度结束*/
    }
  }

  .svg_icon{
    width: 80px;
    height: 80px;
  }
</style>
